import defineProperty from './_define_property';
[['sortBy', v => v], ['sortByDesc', v => !v]].forEach(sortType => {
  let name = sortType[0];
  let compare = sortType[1];
  defineProperty(Array, name, function (f) {
    for (var i = 0; i < this.length; i++) {
      var o = this[i];
      this[i] = [].concat(f.call(o, o, i), o);
    }

    this.sort(function (a, b) {
      for (var i = 0, len = a.length; i < len; ++i) {
        if (a[i] != b[i]) return compare(a[i] < b[i]) ? -1 : 1;
      }

      return 0;
    });

    for (var i = this.length; i;) {
      this[--i] = this[i][this[i].length - 1];
    }

    return this;
  });
});